// extracted by mini-css-extract-plugin
export default {"form":"_3PbytFjMmbIV02owaXz-ru"};